import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ApiService } from '../../shared/services/api.service';
import { MaterialModule } from '../../shared/theming/material/material.module';
import { RedirectCheckRun } from '../../shared/models/redirect-check.model';
import { take } from 'rxjs';
import { Router } from '@angular/router';

export interface FlatRedirectRow {
  date: string;
  source: string;
  expectedDestination: string;
  actualDestination: string;
  passed: boolean;
}

@Component({
  selector: 'app-check-redirects',
  standalone: true,
  imports: [MaterialModule, CommonModule, FormsModule],
  providers: [provideNativeDateAdapter()],
  templateUrl: './check-redirects.component.html',
  styleUrls: ['./check-redirects.component.scss'],
})
export class CheckRedirectsComponent implements OnInit {
  private apiService = inject(ApiService);
  private router = inject(Router);

  calendarStart: Date | null = null;
  endDate: Date | null = null;
  isLoading = false;

  displayedColumns: string[] = [
    'date',
    'source',
    'expectedDestination',
    'actualDestination',
    'passed',
  ];
  dataSource = new MatTableDataSource<FlatRedirectRow>([]);

  redirectType: string = '';
  redirectTypeOptions = [
    { value: 'domestic_and_general', label: 'Domestic & General' },
    { value: 'scottish_power', label: 'Scottish Power' },
  ];

  ngOnInit(): void {
    this.fetchRedirectChecks();
  }

  fetchRedirectChecks(): void {
    this.isLoading = true;
    const params: Record<string, string> = {};

    if (this.calendarStart) {
      params['calendarStart'] = this.calendarStart.toISOString().split('T')[0];
    }
    if (this.endDate) {
      params['endDate'] = this.endDate.toISOString().split('T')[0];
    }

    if (this.redirectType) {
      params['redirectType'] = this.redirectType;
    }

    this.apiService
      .get<{ data: RedirectCheckRun[] }>('admin/fetch-redirect-checks', params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.dataSource.data = response.data.flatMap((run) =>
            run.results.map((result) => ({
              date: run.sk,
              source: result.source,
              expectedDestination: result.expectedDestination,
              actualDestination: result.actualDestination,
              passed: result.passed,
            }))
          );
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleString('en-GB');
  }

  backToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}
